export const FirebaseConfig = {
	"projectId": "jool-b01b1",
	"appId": "1:469774440009:web:081dd4ef2419e030da5198",
	"databaseURL": "https://jool-b01b1-default-rtdb.europe-west1.firebasedatabase.app",
	"storageBucket": "jool-b01b1.appspot.com",
	"locationId": "europe-west2",
	"apiKey": "AIzaSyCbETCmiBETT_3EeACcVff_jGycSr-3Gbc",
	"authDomain": "jool-b01b1.firebaseapp.com",
	"messagingSenderId": "469774440009"
};